import { FC, PropsWithChildren } from 'react';
import { StyledBottomNav } from './BottomNav.styles';

/**
Mobile-focused fixed navigation bar anchored to the bottom of the screen
*/
export const BottomNav: FC<PropsWithChildren> = ({ children }) => {
  return <StyledBottomNav>{children}</StyledBottomNav>;
};

export default BottomNav;
